import { IonList } from '@ionic/react';
import { Player } from '@lottiefiles/react-lottie-player';
import { ReactElement } from 'react';
import i18n from '../../../i18n';
import { BaseButton } from '../../button/base-button';
import { LoadingButton } from '../../button/loading-button';
import { IonItem } from '../../ionic/IonItem';
import { LoginConfirmProps } from '../login-confirm';
import checking from '../lottie/checking.json';

const CheckingLogin = (props: LoginConfirmProps): ReactElement => {
  const { consumeChallengeOnClick, loading, magicLink } = props;
  return (
    <>
      <IonList lines="none">
        <IonItem>
          <p>{i18n.t('common:login_confirm_validating')}</p>
        </IonItem>
        <div>
          <Player
            src={checking}
            loop={true}
            autoplay={true}
            style={{ height: '150px', width: '150px' }}
          />
        </div>
      </IonList>
      <br />
      <div className="ion-padding-horizontal">
        <LoadingButton
          loading={loading}
          buttonProps={{
            type: 'submit',
            disabled: !magicLink.isValid(),
            expand: 'block',
            onClick: consumeChallengeOnClick,
          }}
        >
          {i18n.t('common:next')}
        </LoadingButton>
      </div>
      <div className="secondary-buttons-grid">
        <BaseButton
          className="right"
          buttonProps={{
            fill: 'clear',
            onClick: () => {
              props.startOverClick();
            },
          }}
        >
          {i18n.t('common:login_start_over')}
        </BaseButton>
      </div>
    </>
  );
};

export { CheckingLogin };
